import React from 'react';
import Nav from 'react-bootstrap/Nav';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { INavBarItem } from '../../../types/menu';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function NavItemComponent(props: INavBarItem, key: number) {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isRtl = currentLanguage === 'ar';

  // Using optional chaining to check if items exist and have length greater than 0
  const hasItems1 = (props.items1?.length || 0) > 0;
  const hasItems2 = (props.items2?.length || 0) > 0;
  const hasItems = hasItems1 || hasItems2;

  return (
    <Nav.Item as="li" key={key}>
      {hasItems ? (
        <DropdownButton
          title={
            <>
              {props.title}
              {props.isIcon && <img src="/static/img/notification.png" alt="img" className="img-fluid" />}
            </>
          }
          variant=""
          data-bs-display="static"
          aria-expanded="false"
          as={ButtonGroup}
        >
          <div className={`d-flex ${isRtl ? 'rtl' : 'ltr'}`}>
            {props.items1 && (
              <div className="item">
                <ul>
                  {props.items1.map((item: INavBarItem) => (
                    <li key={item.link}>
                      <a href={item.link} target={item.target || '_self'} className="dropdown-item">
                        {isRtl ? (
                          <>
                            <img src="/static/img/arrow-left.png" alt={item.title} /> {item.title}
                          </>
                        ) : (
                          <>
                           <img src="/static/img/arrow-right.png" alt={item.title} /> {item.title}
                          </>
                        )}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {props.items2 && (
              <div className="item">
                <ul>
                  {props.items2.map((item: INavBarItem) => (
                    <li key={item.link}>
                      <a href={item.link} target={item.target || '_self'} className="dropdown-item">
                        {isRtl ? (
                          <>
                            <img src="/static/img/arrow-left.png" alt={item.title} /> {item.title}
                          </>
                        ) : (
                          <>
                            <img src="/static/img/arrow-left.png" alt={item.title} /> {item.title}
                            </>
                        )}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </DropdownButton>
      ) : (
        <Link to={props.link} className="btn btn-dropdown">
          {props.title}
          {props.isIcon && <img src="/static/img/notification.png" alt="img" className="img-fluid" />}
        </Link>
      )}
    </Nav.Item>
  );
}

export default NavItemComponent;
